import React, { useState } from 'react';

import Button from '../../common/ui/Button';
import CancellationModal from './CancellationModal';
import PolicyModal from './PolicyModal';
import SelectAddressCancellationModal from './SelectAddressCancellationModal';
import SuccessModal from './SuccessModal';
import fetchRequest from '../../../utils/fetchRequest';
import StartCancellationModal from './StartCancellationModal';
import ErrorModal from './ErrorModal';

const DeviceSubCancellation = ({
  subId,
  addressId,
  deviceSn,
  expired,
  nextChargeDate,
  className,
  handleCancelSub,
}) => {
  const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [returnLabel, setReturnLabel] = useState(false);
  const [cancellationType, setCancellationType] = useState(null);

  const [address, setAddress] = useState(null);
  const [isStartModalOpen, setIsStartModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPolicyModalOpen, setIsPolicyModalOpen] = useState(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const onSubmitForm = async (data) => {
    setIsLoading(true);
    try {
      await fetchRequest.post(`/subscriptions/${subId}/cancel`, {
        type: cancellationType,
        address: address,
        device_sn: deviceSn,
        recharge_sub_id: subId,
        cancellation_reason_wing: data.wingReason,
        cancellation_reason_recharge: data.rechargeReason,
      });
      setIsCancellationModalOpen(false);
      await handleCancelSub();
      const returnLabelData = await fetchRequest.get(
        `/subscriptions/${subId}/return_label`,
      );
      if (!returnLabelData?.data?.returnLabel) {
        throw Error('No Return Label');
      }
      setReturnLabel(returnLabelData?.data?.returnLabel);
      setIsSuccessModalOpen(true);
    } catch (e) {
      setIsCancellationModalOpen(false);
      setIsErrorModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const onAddressSelect = (data) => {
    setAddress(data);
    setIsAddressModalOpen(false);
    setIsCancellationModalOpen(true);
  };

  const onCancellationTypeChange = (value) => {
    setCancellationType(value);
    setIsStartModalOpen(false);
    setIsAddressModalOpen(true);
  };

  const handleAddressBackBtn = () => {
    setIsStartModalOpen(true);
    setIsAddressModalOpen(false);
  };

  return (
    <>
      {!expired && (
        <div className={className}>
          <p>
            <span>Next Charge</span>
            {nextChargeDate}
          </p>
          <Button colorType="grey" onClick={() => setIsStartModalOpen(true)}>
            Cancel Subscription
          </Button>
        </div>
      )}
      <StartCancellationModal
        isOpen={isStartModalOpen}
        onClose={() => setIsStartModalOpen(false)}
        nextChargeDate={nextChargeDate}
        submitHandler={onCancellationTypeChange}
      />
      <CancellationModal
        isOpen={isCancellationModalOpen}
        close={() => setIsCancellationModalOpen(false)}
        submitHandler={onSubmitForm}
        isLoading={isLoading}
      />
      <SelectAddressCancellationModal
        isOpen={isAddressModalOpen}
        addressId={addressId}
        backHandler={handleAddressBackBtn}
        onClose={() => setIsAddressModalOpen(false)}
        submitHandler={onAddressSelect}
        isLoading={isLoading}
      />
      <PolicyModal
        isOpen={isPolicyModalOpen}
        onClose={() => setIsPolicyModalOpen(false)}
      />
      <SuccessModal
        isOpen={isSuccessModalOpen}
        cancellationType={cancellationType}
        returnLabel={returnLabel}
        nextChargeDate={nextChargeDate}
        onClose={() => setIsSuccessModalOpen(false)}
      />
      <ErrorModal
        isOpen={isErrorModalOpen}
        onClose={() => setIsErrorModalOpen(false)}
      />
    </>
  );
};
export default DeviceSubCancellation;
